import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const CompareContext = createContext(null);

export const CompareProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("industrialpro-compare") || "[]"); }
    catch { return []; }
  });

  useEffect(() => localStorage.setItem("industrialpro-compare", JSON.stringify(items)), [items]);

  const value = useMemo(() => ({
    items,
    toggle(machine) {
      setItems((current) => {
        if (current.some((item) => item.id === machine.id)) {
          toast.info("Removed from comparison");
          return current.filter((item) => item.id !== machine.id);
        }
        if (current.length >= 4) {
          toast.error("Compare up to four machines at a time");
          return current;
        }
        toast.success("Added to comparison");
        return [...current, machine];
      });
    },
    clear() { setItems([]); },
  }), [items]);

  return <CompareContext.Provider value={value}>{children}</CompareContext.Provider>;
};

export const useCompare = () => useContext(CompareContext);